import { ActionReducer } from '@ngrx/store';
import { Address } from 'src/app/core/models/common/address.model';
import { CustomerSearch } from 'src/app/core/models/customer-portfolio/customerSearch.model';
import * as CustomerPortfolioActions from 'src/app/core/store/onboarding/actions/customer-portfolio.actions';
import { StateManagementHelpers } from '../../helpers';
import { ICustomerPortfolioStore } from '../interfaces/customer-portfolio-store.interface';

const defaultCustomerPortfolioStore: ICustomerPortfolioStore = {
  clientCustomerId: 0,
  clientId: 0,
  CustomerRefNumber: '',
  customerName: '',
  isFederal: false,
  federalDocumentNumber: 0,
  billingAddress: new Address(),
  headquarterAddress: new Address(),
  headquarterCountry: '',
  isHeadquarterAddress: false,
  customerType: { id: -1, value: '' },
  monthlyInvoiceAmount: '',
  invoiceTerm: { id: -1, value: '' },
  billingCountry: '',
  physicalCountry: '',
  physicalAddress: new Address(),
  customerSearch: new CustomerSearch(),
  buyerId: 0,
  buyerName: '',
  buyerAddress: '',
  buyerCity: '',
  buyerPostcode: '',
  buyerCountryCode: '',
  buyerRegion: '',
  buyerRegionCode: '',
};

export const customerPortfolioReducer: ActionReducer<
  ICustomerPortfolioStore | undefined,
  any
> = (
  // eslint-disable-next-line default-param-last
  state: ICustomerPortfolioStore = defaultCustomerPortfolioStore,
  action: any
): ICustomerPortfolioStore | undefined => {
  switch (action.type) {
    case CustomerPortfolioActions.ALL:
      return StateManagementHelpers.mergeState(state, {
        CustomerRefNumber: action.CustomerRefNumber,
        customerName: action.customerName,
        isFederal: action.isFederal,
        federalDocumentNumber: action.federalDocumentNumber,
        billingCountry: action.billingCountry,
        physicalCountry: action.physicalCountry,
        billingAddress: action.billingAddress,
        headquarterAddress: action.headquarterAddress,
        invoiceTerm: action.invoiceTerm,
        clientCustomerId: action.clientCustomerId,
        monthlyInvoiceAmount: action.monthlyInvoiceAmount,
        isHeadquarterAddress: action.isHeadquarterAddress,
      }) as ICustomerPortfolioStore;
    case CustomerPortfolioActions.CUSTOMER_NAME_AND_REF_NUMBER:
      return StateManagementHelpers.mergeState(state, {
        CustomerRefNumber: action.CustomerRefNumber,
        customerName: action.customerName,
      }) as ICustomerPortfolioStore;
    case CustomerPortfolioActions.CUSTOMER_NAME_AND_ID:
      return StateManagementHelpers.mergeState(state, {
        clientCustomerId: action.clientCustomerId,
        customerName: action.customerName,
      }) as ICustomerPortfolioStore;
    case CustomerPortfolioActions.FEDERAL_OR_AGENCY:
      return StateManagementHelpers.mergeState(state, {
        isFederal: action.isFederal,
      }) as ICustomerPortfolioStore;

    case CustomerPortfolioActions.FEDERAL_DOCUMENT_NUMBER:
      return StateManagementHelpers.mergeState(state, {
        federalDocumentNumber: action.federalDocumentNumber,
      }) as ICustomerPortfolioStore;

    case CustomerPortfolioActions.BILLING_COUNTRY:
      return StateManagementHelpers.mergeState(state, {
        billingCountry: action.billingCountry,
      }) as ICustomerPortfolioStore;
    case CustomerPortfolioActions.HEADQUARTER_COUNTRY:
      return StateManagementHelpers.mergeState(state, {
        headquarterCountry: action.headquarterCountry,
      }) as ICustomerPortfolioStore;
    case CustomerPortfolioActions.PHYSICAL_COUNTRY:
      return StateManagementHelpers.mergeState(state, {
        physicalCountry: action.physicalCountry,
      }) as ICustomerPortfolioStore;

    case CustomerPortfolioActions.PHYSICAL_ADDRESS:
      return StateManagementHelpers.mergeState(state, {
        physicalAddress: action.physicalAddress,
      }) as ICustomerPortfolioStore;

    case CustomerPortfolioActions.BILLING_ADDRESS:
      return StateManagementHelpers.mergeState(state, {
        billingAddress: action.billingAddress,
      }) as ICustomerPortfolioStore;
    case CustomerPortfolioActions.HEADQUARTER_ADDRESS:
      return StateManagementHelpers.mergeState(state, {
        headquarterAddress: action.headquarterAddress,
      }) as ICustomerPortfolioStore;
    case CustomerPortfolioActions.INVOICE_TERM:
      return StateManagementHelpers.mergeState(state, {
        invoiceTerm: action.invoiceTerm,
      }) as ICustomerPortfolioStore;
    case CustomerPortfolioActions.CLIENT_CUSTOMER_ID:
      return StateManagementHelpers.mergeState(state, {
        clientCustomerId: action.clientCustomerId,
      }) as ICustomerPortfolioStore;
    case CustomerPortfolioActions.INVOCIE_AMOUNT_PER_MONTH:
      return StateManagementHelpers.mergeState(state, {
        monthlyInvoiceAmount: action.monthlyInvoiceAmount,
      }) as ICustomerPortfolioStore;
    case CustomerPortfolioActions.IS_HEADQUARTER_ADDRESS:
      return StateManagementHelpers.mergeState(state, {
        isHeadquarterAddress: action.isHeadquarterAddress,
      }) as ICustomerPortfolioStore;
    case CustomerPortfolioActions.CUSTOMER_SEARCH:
      return StateManagementHelpers.mergeState(state, {
        customerSearch: action.customerSearch,
      }) as ICustomerPortfolioStore;
    case CustomerPortfolioActions.CLEAR:
      return StateManagementHelpers.mergeState(state, {
        clientCustomerId: 0,
        clientId: 0,
        CustomerRefNumber: '',
        customerName: '',
        isFederal: false,
        country: '',
        billingAddress: new Address(),
        headquarterAddress: new Address(),
        isHeadquarterAddress: false,
        customerType: { id: -1, value: '' },
        monthlyInvoiceAmount: '',
        invoiceTerm: { id: -1, value: '' },
        billingCountry: '',
        headquarterCountry: '',
        physicalCountry: '',
        federalDocumentNumber: 0,
        customerSearch: new CustomerSearch(),
      }) as ICustomerPortfolioStore;
    default:
      return state;
  }
};
